import React from 'react';

import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';

interface Props {
  approved: boolean;
  count?: number;
}

export default function ApprovalStatusChip({ approved, count }: Props) {
  const label = count != null ? `${count} ${approved ? 'approved' : 'requires approval'}` : getSingularLabel(approved);
  const color = approved ? 'success' : 'warning';

  return (
    <Chip
      label={label}
      size="small"
      color={color}
      variant="outlined"
      sx={{ bgcolor: (theme) => alpha(theme.palette[color].light, 0.06), fontWeight: 700 }}
    />
  );
}

function getSingularLabel(approved: boolean) {
  return approved ? 'Approved' : 'Requires approval';
}
